<template>
  <div class="kq-refund" :aria-busy="loading">
    <div v-if="loading" class="kq-refund-hint" role="status">快钱退款结果查询中...</div>
    <div v-else-if="error" class="kq-refund-error" role="alert">
      <span>快钱退款结果查询失败：{{ error }}</span>
      <button v-if="tradeNo" type="button" class="kq-refund-retry" @click="loadStatus">重试</button>
    </div>
    <template v-else>
      <div v-if="!transactions.length" class="kq-refund-hint">快钱：暂无退款结果</div>
      <div
        v-for="(txn, index) in transactions"
        :key="index"
        class="kq-refund-result"
        :class="resultClass(txn)"
      >快钱：{{ resultText(txn) }}</div>
    </template>
  </div>
</template>

<script>
import { getKqPayStatus } from "@/utils/userQueryApi";
import { parseKqRefundStatus } from "@/utils/kqRefund";

export default {
  name: "KqRefundStatus",
  props: {
    tradeNo: { type: [String, Number], default: "" },
  },
  data() {
    return { loading: false, error: "", transactions: [], requestId: 0 };
  },
  watch: {
    tradeNo: {
      immediate: true,
      handler() {
        this.loadStatus();
      },
    },
  },
  beforeUnmount() {
    this.requestId += 1;
  },
  methods: {
    async loadStatus() {
      const requestId = ++this.requestId;
      const tradeNo = String(this.tradeNo ?? "").trim();
      this.transactions = [];
      this.error = "";
      this.loading = false;
      if (!tradeNo) {
        this.error = "缺少付款订单号";
        return;
      }
      this.loading = true;
      try {
        const response = await getKqPayStatus(tradeNo);
        if (requestId !== this.requestId) return;
        this.transactions = parseKqRefundStatus(response);
      } catch (error) {
        if (requestId !== this.requestId) return;
        this.error = error?.message || "网络异常，请稍后重试";
      } finally {
        if (requestId === this.requestId) this.loading = false;
      }
    },
    resultText(txn) {
      const message = String(txn.rfdResponseMessage ?? "").trim();
      if (message) return message;
      const code = String(txn.rfdResponseCode ?? "").trim();
      if (code === "00") return "退款成功";
      return code ? `退款失败（${code}）` : "暂无退款结果";
    },
    resultClass(txn) {
      const code = String(txn.rfdResponseCode ?? "").trim();
      if (code === "00") return "kq-refund-success";
      return code ? "kq-refund-error" : "kq-refund-hint";
    },
  },
};
</script>

<style scoped>
.kq-refund {
  font-size: 12px;
  overflow-wrap: anywhere;
}
.kq-refund-result + .kq-refund-result { margin-top: 4px; }
.kq-refund-hint { color: #6b6966; }
.kq-refund-success { color: #2d6a2e; }
.kq-refund-error { color: #a63a32; }
.kq-refund-retry {
  margin-left: 6px;
  padding: 2px 6px;
  border: 1px solid #d0ccc5;
  border-radius: 4px;
  background: #fff;
  color: #37352f;
  font: inherit;
  cursor: pointer;
}
.kq-refund-retry:hover { background: #f0efed; }
.kq-refund-retry:focus-visible { outline: 2px solid #2878b5; outline-offset: 2px; }
</style>
